import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import * as getters from './getter';
import actions from './action';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

const modules = {};
const debug = process.env.NODE_ENV !== 'production';
// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules,
  plugins: debug ? [createLogger()] : [],
});



// WEBPACK FOOTER //
// ./src/store/index.js